import React from "react";
import '../css/main.css';

const steps = [
  {
    title: "Choose Accessibility Option",
    desc: "Select the desired accessibility option: Audio Description (AD) or Indian Sign Language (ISL).",
  },
  {
    title: "Upload Video",
    desc: "Upload a video from your device or provide a YouTube link to begin processing.",
  },
  {
    title: "AI Processing",
    desc: "The system analyzes the video and generates the selected output using AI.",
  },
  {
    title: "Preview & Download",
    desc: "Preview the result online or download the video with integrated AD or ISL.",
  },
];

const HomeHowItWorks = () => {
  return (
//     <section className="how-section" id="howitworks">
//  <div className="section-title text-center">
//                   <h2>How It Works </h2>
                 
//                 </div>
//       <div className="how-steps">
      
       
//           <div className="how-step" key="1">
//             <div className="how-circle">1</div>
//             <h4>Choose Accessibility Option</h4>
//             <p>Select the desired accessibility option: Audio Description (AD) or 
//               Indian Sign Language (ISL)
// </p>
//           </div>
        
//          <div className="how-step" key="2">
//             <div className="how-circle">2</div>
//             <h4>Upload Video</h4>
//             <p>Upload a video from your device or provide a YouTube link to begin processing.
//           </p>
//           </div>
//  <div className="how-step" key="3">
//             <div className="how-circle">3</div>
//             <h4>AI Processing</h4>
//             <p>The system analyzes the video and generates the selected output using AI.
//           </p>
//           </div>
// <div className="how-step" key="4">
//             <div className="how-circle">4</div>
//             <h4>Preview & Download</h4>
//             <p>Preview the result online or download the video with integrated AD or ISL.
//           </p>
//           </div>

//       </div>
//     </section>


<section
  className="how-section"
  id="howitworks"
  role="region"
  aria-labelledby="how-it-works-heading"
>
 
  <div className="section-title text-center">
    <h2 id="how-it-works-heading">How It Works</h2>
  </div>


  <ol
    className="how-steps"
    aria-label="Steps to use the application"
  >
    <li className="how-step" tabIndex="0">
      <span className="how-circle" aria-hidden="true">1</span>
      <h4>Choose Accessibility Option</h4>
      <p>
        Select the desired accessibility option: Audio Description (AD)
        or Indian Sign Language (ISL).
      </p>
    </li>

    <li className="how-step" tabIndex="0">
      <span className="how-circle" aria-hidden="true">2</span>
      <h4>Upload Video</h4>
      <p>
        Upload a video from your device or provide a YouTube link to begin processing.
      </p>
    </li>

    <li className="how-step" tabIndex="0">
      <span className="how-circle" aria-hidden="true">3</span>
      <h4>AI Processing</h4>
      <p>
        The system analyzes the video and generates the selected output using AI.
      </p>
    </li>

    <li className="how-step" tabIndex="0">
      <span className="how-circle" aria-hidden="true">4</span>
      <h4>Preview and Download</h4>
      <p>
        Preview the result online or download the video with integrated
        audio description or Indian Sign Language.
      </p>
    </li>
  </ol>
</section>



  );
};

export default HomeHowItWorks;
